export const enFoodDelivery = {
  hero: {
    title: "Multi-Restaurant Food Delivery Marketplace",
    subtitle: "Complete food delivery platform with multi-restaurant support and dedicated mobile apps",
    imageAlt: "Food delivery app interface showing order tracking"
  },
  features: {
    multiRestaurant: {
      title: "Multi-Restaurant Platform",
      description: "Support for unlimited restaurants with individual management panels and customizable storefronts"
    },
    mobileApps: {
      title: "Dedicated Mobile Apps",
      description: "High-performance Flutter apps for customers, drivers, and restaurants (iOS & Android)"
    },
    posSystem: {
      title: "Restaurant POS System",
      description: "Complete point-of-sale solution with kitchen display integration and order management"
    },
    deliveryApp: {
      title: "Driver Application",
      description: "Specialized delivery app with route optimization, real-time tracking, and earnings dashboard"
    },
    monetization: {
      title: "Multiple Revenue Streams",
      description: "Flexible monetization through commissions, subscriptions, advertising, and dynamic service fees"
    },
    security: {
      title: "Enterprise Security",
      description: "End-to-end encryption, OTP authentication, 2FA, and PCI-compliant payment processing"
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      php: "PHP 8.2+ with Laravel Octane",
      laravel: "Laravel 10 with API resources",
      database: "MySQL 8 with Redis caching"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 for cross-platform apps",
      web: "React.js with Next.js for admin portal",
      state: "Riverpod for state management"
    },
    integrations: {
      title: "Integrations",
      payments: "Stripe, PayPal, and local payment processors",
      maps: "Google Maps and Mapbox integration",
      analytics: "Firebase Analytics and Mixpanel"
    }
  },
  dashboard: {
    title: "Powerful Management Dashboard",
    description: "Complete control over your food delivery operations with real-time business intelligence",
    demoAlt: "Food delivery admin dashboard preview",
    features: {
      "1": "Multi-restaurant management system",
      "2": "Dynamic delivery zone configuration",
      "3": "Promotions and loyalty programs",
      "4": "Real-time business analytics",
      "5": "Automated commission tracking"
    }
  },
  cta: {
    title: "Ready to Launch Your Food Delivery Service?",
    description: "Our complete platform will help you start and grow your food delivery business",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the food delivery platform"
  },
  demo:{
    title: "Food Delivery Demo",
  }
};

export const frFoodDelivery = {
  hero: {
    title: "Marché de Livraison de Nourriture Multi-Restaurants",
    subtitle: "Plateforme complète de livraison de nourriture avec support multi-restaurants et applications mobiles dédiées",
    imageAlt: "Interface de l'application de livraison de nourriture montrant le suivi des commandes"
  },
  features: {
    multiRestaurant: {
      title: "Plateforme Multi-Restaurant",
      description: "Support pour un nombre illimité de restaurants avec des panneaux de gestion individuels et des vitrines personnalisables"
    },
    mobileApps: {
      title: "Applications Mobiles Dédiées",
      description: "Applications Flutter haute performance pour les clients, les livreurs et les restaurants (iOS & Android)"
    },
    posSystem: {
      title: "Système POS pour Restaurants",
      description: "Solution complète de point de vente avec intégration d'affichage en cuisine et gestion des commandes"
    },
    deliveryApp: {
      title: "Application de Livraison",
      description: "Application de livraison spécialisée avec optimisation des itinéraires, suivi en temps réel et tableau de bord des gains"
    },
    monetization: {
      title: "Multiples Sources de Revenus",
      description: "Monétisation flexible via des commissions, des abonnements, de la publicité et des frais de service dynamiques"
    },
    security: {
      title: "Sécurité d'Entreprise",
      description: "Chiffrement de bout en bout, authentification OTP, 2FA et traitement des paiements conforme PCI"
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      php: "PHP 8.2+ avec Laravel Octane",
      laravel: "Laravel 10 avec ressources API",
      database: "MySQL 8 avec mise en cache Redis"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 pour des applications multiplateformes",
      web: "React.js avec Next.js pour le portail administrateur",
      state: "Riverpod pour la gestion de l'état"
    },
    integrations: {
      title: "Intégrations",
      payments: "Stripe, PayPal et processeurs de paiement locaux",
      maps: "Intégration de Google Maps et Mapbox",
      analytics: "Firebase Analytics et Mixpanel"
    }
  },
  dashboard: {
    title: "Tableau de Bord de Gestion Puissant",
    description: "Contrôle total de vos opérations de livraison de nourriture avec des informations commerciales en temps réel",
    demoAlt: "Aperçu du tableau de bord administrateur de livraison de nourriture",
    features: {
      "1": "Système de gestion multi-restaurants",
      "2": "Configuration dynamique des zones de livraison",
      "3": "Promotions et programmes de fidélité",
      "4": "Analytique commerciale en temps réel",
      "5": "Suivi automatisé des commissions"
    }
  },
  cta: {
    title: "Prêt à Lancer Votre Service de Livraison de Nourriture?",
    description: "Notre plateforme complète vous aidera à démarrer et à développer votre entreprise de livraison de nourriture",
    buttonText: "Voir la Démo",
    buttonAriaLabel: "Voir la démo de la plateforme de livraison de nourriture"
  },
  demo:{
    title: "Démo de Livraison de Nourriture",
  }
};

export const nlFoodDelivery = {
  hero: {
    title: "Multi-Restaurant Food Delivery Marktplaats",
    subtitle: "Compleet food delivery platform met ondersteuning voor meerdere restaurants en speciale mobiele apps",
    imageAlt: "Food delivery app-interface toont ordertracking"
  },
  features: {
    multiRestaurant: {
      title: "Multi-Restaurant Platform",
      description: "Ondersteuning voor onbeperkt aantal restaurants met individuele beheerpanelen en aanpasbare etalages"
    },
    mobileApps: {
      title: "Speciale Mobiele Apps",
      description: "Hoogwaardige Flutter-apps voor klanten, bezorgers en restaurants (iOS & Android)"
    },
    posSystem: {
      title: "Restaurant POS-systeem",
      description: "Compleet kassasysteem met keukenweergave-integratie en orderbeheer"
    },
    deliveryApp: {
      title: "Bezorgersapplicatie",
      description: "Gespecialiseerde bezorgersapp met routeoptimalisatie, realtime tracking en inkomsten-dashboard"
    },
    monetization: {
      title: "Meerdere Inkomststromen",
      description: "Flexibele monetisatie via commissies, abonnementen, advertenties en dynamische servicekosten"
    },
    security: {
      title: "Enterprise Beveiliging",
      description: "End-to-end encryptie, OTP-authenticatie, 2FA en PCI-conforme betalingsverwerking"
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      php: "PHP 8.2+ met Laravel Octane",
      laravel: "Laravel 10 met API-resources",
      database: "MySQL 8 met Redis-caching"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 voor cross-platform apps",
      web: "React.js met Next.js voor adminportaal",
      state: "Riverpod voor state management"
    },
    integrations: {
      title: "Integraties",
      payments: "Stripe, PayPal en lokale betaalproviders",
      maps: "Google Maps en Mapbox-integratie",
      analytics: "Firebase Analytics en Mixpanel"
    }
  },
  dashboard: {
    title: "Krachtig Beheerdashboard",
    description: "Volledige controle over uw food delivery-operaties met realtime business intelligence",
    demoAlt: "Preview van food delivery admin dashboard",
    features: {
      "1": "Multi-restaurant beheersysteem",
      "2": "Dynamische configuratie van bezorgzones",
      "3": "Promoties en loyaliteitsprogramma's",
      "4": "Realtime bedrijfsanalyses",
      "5": "Geautomatiseerde commissietracking"
    }
  },
  cta: {
    title: "Klaar om uw food delivery service te lanceren?",
    description: "Ons complete platform helpt u uw food delivery bedrijf te starten en te laten groeien",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het food delivery platform"
  },
  demo:{
    title: "Food Delivery Demo",
  }
};

export const deFoodDelivery = {
  hero: {
    title: "Multi-Restaurant Food Delivery Marktplatz",
    subtitle: "Komplette Food Delivery Plattform mit Multi-Restaurant-Unterstützung und eigenen mobilen Apps",
    imageAlt: "Food Delivery App-Oberfläche zeigt Bestellverfolgung"
  },
  features: {
    multiRestaurant: {
      title: "Multi-Restaurant Plattform",
      description: "Unterstützung für unbegrenzte Restaurants mit individuellen Verwaltungs-Panels und anpassbaren Storefronts"
    },
    mobileApps: {
      title: "Eigene Mobile Apps",
      description: "Leistungsstarke Flutter-Apps für Kunden, Fahrer und Restaurants (iOS & Android)"
    },
    posSystem: {
      title: "Restaurant POS-System",
      description: "Komplettes Kassensystem mit Küchenanzeige-Integration und Bestellmanagement"
    },
    deliveryApp: {
      title: "Fahrer-App",
      description: "Spezialisierte Fahrer-App mit Routenoptimierung, Echtzeit-Tracking und Verdienst-Dashboard"
    },
    monetization: {
      title: "Mehrere Einnahmequellen",
      description: "Flexible Monetarisierung durch Provisionen, Abonnements, Werbung und dynamische Servicegebühren"
    },
    security: {
      title: "Enterprise-Sicherheit",
      description: "End-to-End-Verschlüsselung, OTP-Authentifizierung, 2FA und PCI-konforme Zahlungsabwicklung"
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      php: "PHP 8.2+ mit Laravel Octane",
      laravel: "Laravel 10 mit API-Ressourcen",
      database: "MySQL 8 mit Redis-Caching"
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter 3 für plattformübergreifende Apps",
      web: "React.js mit Next.js für das Admin-Portal",
      state: "Riverpod für State Management"
    },
    integrations: {
      title: "Integrationen",
      payments: "Stripe, PayPal und lokale Zahlungsanbieter",
      maps: "Google Maps und Mapbox-Integration",
      analytics: "Firebase Analytics und Mixpanel"
    }
  },
  dashboard: {
    title: "Leistungsstarkes Verwaltungsdashboard",
    description: "Vollständige Kontrolle über Ihre Food Delivery-Operationen mit Echtzeit-Business Intelligence",
    demoAlt: "Vorschau des Food Delivery Admin Dashboards",
    features: {
      "1": "Multi-Restaurant-Managementsystem",
      "2": "Dynamische Lieferzonen-Konfiguration",
      "3": "Aktionen und Treueprogramme",
      "4": "Echtzeit-Geschäftsanalysen",
      "5": "Automatisiertes Provisions-Tracking"
    }
  },
  cta: {
    title: "Bereit, Ihren Food Delivery Service zu starten?",
    description: "Unsere komplette Plattform hilft Ihnen, Ihr Food Delivery Geschäft zu starten und zu wachsen",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der Food Delivery Plattform ansehen"
  },
  demo:{
    title: "Food Delivery Demo",
  }
};